<div *ngIf="show">
  <div *ngIf="!hiddenTag" class="d-flex align-items-center gap-2 mb-1">
    <p-progressSpinner *ngIf="!finished" strokeWidth="4"
      [style]="{ width: '1.2rem', height: '1.2rem', display: 'flex' }" styleClass="progress-status-spinner" />
    <p-tag class="text-left" [severity]="finished ? 'success' : 'warn'" [value]="statusMessage" />
  </div>
  <p-progressbar mode="{{mode}}" [value]="value" [style]="{ height: heightProgress }" [color]="'#005cbb'">
    <ng-template #content let-value>
      <div [style.width]="'100%'" [style.overflow]="'hidden'" [style.white-space]="'nowrap'">
        <span [style.font-size]="'10px'" [style.display]="'inline-block'">
          <!-- {{value}}% -->
          {{currentValue}}/{{totalValue}}
        </span>
      </div>
    </ng-template>
  </p-progressbar>
</div>